"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const ReactDOM = require("react-dom");
const react_redux_1 = require("react-redux");
const react_responsive_1 = require("react-responsive");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const AlertOptionsRows_1 = require("./AlertOptionsRows");
const AlertOptionsPhonePreview_1 = require("./AlertOptionsPhonePreview");
const FormSection_1 = require("../../utils/FormSection");
const reducers_1 = require("../../../reducers");
class AlertOptionsContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hoverField: '',
        };
        this.handleHover = this.handleHover.bind(this);
    }
    componentDidUpdate() {
        const { hoverField } = this.state;
        const hoverArrowId = `${hoverField}_hoverArrow`;
        const hoverRow = document.getElementById(`${hoverField}_alertOptionsRow`);
        const hoverArrow = document.getElementById(hoverArrowId);
        if (hoverRow && hoverArrow) {
            hoverArrow.style.top = `${hoverRow.getBoundingClientRect().top -
                (hoverArrow.getBoundingClientRect().height - hoverRow.getBoundingClientRect().height) / 2}px`;
        }
    }
    handleHover(hoverField) {
        const { device } = this.props;
        if (device === 'Desktop' && window.innerWidth >= 1140) {
            this.setState({
                hoverField,
            });
        }
    }
    getHoverArrow() {
        const { hoverField } = this.state;
        const hoverArrowId = `${hoverField}_hoverArrow`;
        return ReactDOM.createPortal(React.createElement("div", { style: {
                position: 'fixed',
                top: 0,
                left: 758,
                height: 20,
                width: 20,
                transform: 'rotate(45deg)',
                background: src_1.beige,
                border: `1px solid ${src_1.titanium}`,
                borderBottom: 'none',
                borderLeft: 'none',
                borderRadius: '0 5px 0 0',
            }, id: hoverArrowId }), document.getElementById('mainModalRight'));
    }
    getCaretAndPreviewPortals() {
        const { device } = this.props;
        const { hoverField } = this.state;
        const getAlertIcon = () => {
            const style = {
                position: 'absolute',
                top: 96,
                left: 24,
                textAlign: 'center',
                width: 320,
            };
            switch (hoverField) {
                case 'badgeNumber':
                    return (React.createElement("div", { style: Object.assign(Object.assign({}, style), { zIndex: 10 }) },
                        React.createElement(src_1.AlertOptionsBadgeNumber, null),
                        React.createElement(src_1.Text, { text: "Increment the number on your app's badge icon", size: "large", textStyle: {
                                margin: '131px auto',
                                width: 200,
                            } })));
                case 'notificationCenter':
                    return (React.createElement("div", { style: Object.assign(Object.assign({}, style), { backgroundColor: 'white', height: 568, zIndex: 10 }) },
                        React.createElement(src_1.AlertOptionsNotificationCenter, null),
                        React.createElement(src_1.Text, { text: "Add to your app\u2019s Notification Center", size: "large", textStyle: {
                                margin: '131px auto',
                                width: 200,
                            } })));
                case 'systemNotification':
                    return (React.createElement("div", { style: style },
                        React.createElement(src_1.AlertOptionsPushNotification, null),
                        React.createElement(src_1.Text, { text: "Alert users with a system notification", size: "large", textStyle: {
                                margin: '131px auto',
                                width: 151,
                            } })));
                default:
                    return (React.createElement("div", { style: Object.assign(Object.assign({}, style), { height: 568, width: 320, background: 'white linear-gradient(rgba(233,233,233,1.0), rgba(238,238,238,0.5))', zIndex: 10 }) }));
            }
        };
        return ReactDOM.createPortal(getAlertIcon(), document.getElementById('phone-bezel'));
    }
    render() {
        const { device, deviceInfoSelected } = this.props;
        const { hoverField } = this.state;
        return (React.createElement(FormSection_1.default, { device: device },
            React.createElement("div", { style: {
                    paddingTop: 24,
                    paddingBottom: 8,
                } },
                React.createElement(src_1.Text, { text: "Alert Options", size: "h1" })),
            React.createElement("div", { style: {
                    paddingBottom: 24,
                } },
                React.createElement(src_1.Text, { text: "How should the user be alerted when the notification is delivered?", size: "medium" })),
            React.createElement(AlertOptionsRows_1.default, { handleHover: this.handleHover, device: device, field: "systemNotification", displayText: "Push Notification", isHovered: hoverField === 'systemNotification' }),
            React.createElement(AlertOptionsRows_1.default, { handleHover: this.handleHover, device: device, field: "notificationCenter", displayText: "Notification Center", isHovered: hoverField === 'notificationCenter' }),
            React.createElement(AlertOptionsRows_1.default, { handleHover: this.handleHover, device: device, field: "badgeNumber", displayText: "Badge Number", isHovered: hoverField === 'badgeNumber' }),
            device === 'Desktop' && (React.createElement(react_responsive_1.default, { minWidth: 1140 },
                this.getCaretAndPreviewPortals(),
                hoverField !== '' && this.getHoverArrow())),
            deviceInfoSelected.length !== 0 &&
                ReactDOM.createPortal(React.createElement(AlertOptionsPhonePreview_1.default, { device: device, val: deviceInfoSelected }), document.getElementById('mainModalLeft'))));
    }
}
const mapStateToProps = (state) => ({
    deviceInfoSelected: reducers_1.getIsAlertOptionsOpen(state),
});
exports.default = react_redux_1.connect(mapStateToProps, {})(AlertOptionsContainer);
